module.exports = __webpack_public_path__ + "static/img/ES@2x.69d59e0f.jpg";